/**
 * Provides an interface for viewing user information.
 * @module directory/views/Details
 */
import Backbone from "backbone";
import _ from "underscore";
import moment from "moment";
import viewTemplate from "views/user/Details";
import "../../../../styles/specific/user_profile.css";
import Helper from "app/ejs";
import session from "app/Session";

export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {User} options.model The user model associated with the view.
   * @param {app/Context} options.context The context associated with this view.
   */
  initialize: function (options) {
    this.options = options;
  },

  template: Helper.template(viewTemplate),
  className: "directory-view",

  render: function () {
    var options = _.extend(
      {
        allowEdit:
          session.hasRole("admin") ||
          session.hasRole("office") ||
          session.user.id == this.options.model.id,
        isAdmin: session.hasRole("admin"),
      },
      {
        model: this.options.model.attributes,
        moment: moment,
        fullName: this.options.model.fullName(),
        profileImageUrl: "",
      }
    );

    this.$el.html(this.template(options));
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/user/Details.js
// module id = 484
// module chunks = 1